import React, { useReducer, createContext, useState, useEffect } from 'react';

export const FiltersContext = createContext({});

const initialState = {
  pagination: {
    page: 1,
    limit: 25,
  },
  filters: null,
};

const reducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'SET_FILTERS':
      return {
        pagination: {
          page: 1,
          limit: initialState.pagination.limit,
        },
        filters: payload,
      };
    case 'SET_PAGINATON':
      return {
        ...state,
        pagination: {
          page: payload,
          limit: initialState.pagination.limit,
        },
      };
    case 'SET_PAGINATION_AND_LIMIT':
      return {
        ...state,
        pagination: {
          page: payload.page,
          limit: payload.limit,
        },
      };

    case 'RESET':
      return initialState;
    default:
      break;
  }
};

const FiltersProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [queryString, setQueryString] = useState(null);

  useEffect(() => {
    let obj = {};
    let values = Object.assign({}, state.pagination, state.filters);
    for (let item in values) {
      const value = values[item];
      obj[item] = value === null || value === undefined ? '' : value;
    }
    const qs = `?${new URLSearchParams(obj).toString()}`;
    setQueryString(qs);
  }, [state]);

  return (
    <FiltersContext.Provider
      value={{
        ...state,
        dispatch,
        queryString,
        /*
        setFilters: (values) =>
          dispatch({ type: 'SET_FILTERS', payload: values }),
        */
        setPage: (values) =>
          dispatch({ type: 'SET_PAGINATON', payload: values }),
        setPageAndLimit: (values) =>
          dispatch({ type: 'SET_PAGINATION_AND_LIMIT', payload: values }),
      }}
    >
      {children}
    </FiltersContext.Provider>
  );
};

export default FiltersProvider;
